import React, { useState, useEffect, useContext } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import serverUrl from "./Globals";
import CheckoutForm from "./CheckoutForm";
import {UserContext} from "./UserContext";
import "./App.css";
import {  useNavigate } from 'react-router-dom';

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// This is your test publishable API key.

const stripePromise = loadStripe("pk_live_51MzmBRDpmh51SOgFVcxl88FE5mz82gQTqdifzpDSEEft0rd6SyUkaCjt1X63F8DOkRxn78cCnBT1sf4eOnsqvuGI00As66NttM");
// const stripePromise = loadStripe("pk_test_51MzmBRDpmh51SOgF93KWOyxHPFgDiuLD5kkFdLtaaPG8uvlq4rNlcXRKNA5dcxoWXWbSAhRMa92ajdYhNC1oCijK00rbUXFSLT");

export default function Checkout() {
  const {user} = useContext(UserContext);
  const [clientSecret, setClientSecret] = useState("");
  const [idToken, setIdToken] = useState();
  const navigate = useNavigate();
  
  useEffect(()=>{
    if(user)
    setIdToken(user.getIdToken());
  },[]);
  

  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    const token = localStorage.getItem("accessToken");
    if(token){
    fetch(serverUrl+"/api/create-payment-intent", {
      method: "POST",
      headers: { "Content-Type": "application/json" , 'Authorization': `Bearer ${token}`},
      body: JSON.stringify({idToken, items: [{ id: "xl-tshirt" }] }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
    }
    else{
      console.log("no session storage");
      navigate('/login');
    }
  }, [user]);

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <div className="stripe">
      {clientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm />
        </Elements>
      )}
    </div>
  );
}